import React, { useMemo, useState } from 'react';

import { Paper } from '@mui/material';

import ChangeLogSearch from './Components/ChangeLogSearch/index';
import ChangeLogTabs from './Components/ChangeLogTabs';
import commonStyles from '../../../../../commonStyles';
import PageHeading from '../../../../../Components/PageHeading';
import { FEATURE_DESCRIPTION } from '../../../constant';
/**
 * @name ChangeLogs
 * @description Component for displaying the Change Logs page. It includes a search form and tab navigation
 * to view all change logs and details of specific changes.
 * @returns {JSX.Element} - The rendered component.
 */
const ChangeLogs = () => {
	const [allChangeLogs, setAllChangeLogs] = useState([]);
	const [filteredFeature, setFilteredFeature] = useState('');
	const [currentSelectedChange, setCurrentSelectedChange] = useState(null);
	const commonStyleClasses = commonStyles();
	const { SITE_CONFIG } = FEATURE_DESCRIPTION;
	/**
	 * @name filterLogsBySubstring
	 * @description Memoized feature filter that filters logs by substring match in the changes object keys.
	 * If a `filteredFeature` is provided, it filters the `changeLogsArray` accordingly. Otherwise, it returns the full array.
	 * @returns {Array} - The filtered or unfiltered array of log objects.
	 */
	const filteredAllChangeLogs = useMemo(() => {
		const filteredChangeLogsArray = [];
		setCurrentSelectedChange(null);
		if (filteredFeature !== '') {
			allChangeLogs?.forEach((log) => {
				const filteredChanges = {};

				for (const key in log.changes) {
					if (key.includes(filteredFeature)) {
						filteredChanges[key] = log.changes[key];
					}
				}

				if (Object.keys(filteredChanges).length > 0) {
					filteredChangeLogsArray.push({
						...log,
						changes: filteredChanges
					});
				}
			});
		} else {
			return allChangeLogs;
		}

		return filteredChangeLogsArray;
	}, [allChangeLogs, filteredFeature]);

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Change Logs"
				headingPath={['Dashboard', 'Framerate', 'Change Logs']}
				description="Track all the changes made to the setup including information about the user responsible for
				the changes"
				showInfoButton={true}
				infoMessage={SITE_CONFIG.CHANGE_LOGS}
			/>

			<ChangeLogSearch
				updateFilteredFeature={setFilteredFeature}
				filteredFeature={filteredFeature}
				updateCurrentSelectedChange={setCurrentSelectedChange}
				updateAllChangeLogs={setAllChangeLogs}
			/>
			<ChangeLogTabs
				currentSelectedChange={currentSelectedChange}
				updateCurrentSelectedChange={setCurrentSelectedChange}
				filteredAllChangeLogs={filteredAllChangeLogs}
			/>
		</Paper>
	);
};

export default ChangeLogs;
